import axios from "../utils/axiosConfig";
import { toast } from "react-toastify";
import { setAuthData, clearAuthData } from "../reducers/authReducer";
import { API_URL } from "../variables";
import { clearCart } from "../actions/cartActions";

export const loginUser =
  (formData, navigate, redirect = null) =>
  async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/api/users/login`, formData);

      if (response.status === 200) {
        const { token, user } = response.data;
        localStorage.setItem("authToken", token);
        localStorage.setItem("user", JSON.stringify(user));
        dispatch(setAuthData({ user, token }));
        toast.success("Login successful!");
        if (redirect) {
          navigate(redirect);
        } else {
          navigate("/");
        }
      } else {
        toast.error(response.data.message || "Login failed.");
      }
    } catch (error) {
      toast.error("Invalid username or password.");
    }
  };

export const rehydrateAuth = () => (dispatch) => {
  const token = localStorage.getItem("authToken");
  const userStr = localStorage.getItem("user");
  let user = null;

  if (userStr && userStr !== "undefined") {
    try {
      user = JSON.parse(userStr);
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }

  if (token && user) {
    dispatch(setAuthData({ token, user }));
  } else {
    dispatch(clearAuthData());
  }
};

export const logoutUser = (navigate) => async (dispatch) => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      // toast.error("User is not authenticated.");
      return;
    }

    const response = await axios.get(`${API_URL}/api/users/logout`, {
      headers: {
        Authorization: token,
      },
    });

    if (response.status === 200) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      dispatch(clearAuthData());
      dispatch(clearCart());
      toast.success("Logged out successfully!");
      navigate("/signin");
    } else {
      toast.error(response.data.message || "Logout failed.");
    }
  } catch (error) {
    toast.error("An error occurred during logout.");
  }
};

export const updateUser = (formData, navigate) => async (dispatch) => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      toast.error("User is not authenticated.");
      return;
    }

    const response = await axios.post(
      `${API_URL}/api/users/updateMyAccount`,
      formData,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (response.status === 200) {
      const user = response.data.data;
      console.log("user", user);
      localStorage.setItem("user", JSON.stringify(user));
      dispatch(setAuthData({ user, token }));
      toast.success("Account updated successfully!");
      navigate("/myaccount");
    } else {
      toast.error(response.data.message || "Update failed.");
    }
  } catch (error) {
    toast.error("An error occurred during update.");
  }
};
